<template>
  <div class="ui error message">      
    <p>{{message}}</p>
    <div class="ui accordion" ref="debugInfo">
      <div class="ui title active">
        <i class="dropdown icon"></i>
        More info
      </div>
      <div class="content active">
        <pre class="transition visible">{{exception.stack}}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import '../../assets/semantic-ui/components/accordion.min.css'

export default {
  props: ['message', 'exception'],
  mounted() {
  },
}
</script>

<style scoped>
.ui.accordion pre {
  overflow: auto;
}
</style>
